import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { RouteTimelineDtoModelType } from '../../../../../../store/mst/models';
import TimelineCardDropZone, { DropzonePosition } from './TimelineCardDropZone';

export interface DragDropProps {
  dragOriginIndex?: number;
  draggedOverIndex?: number;
  dropzonePosition?: DropzonePosition;
  setDropzonePosition: (position: DropzonePosition | undefined) => void;
  setDragOriginIndex: (index: number | undefined) => void;
  setDraggedOverIndex: (index: number | undefined) => void;
}

interface Props {
  event: RouteTimelineDtoModelType;
  index: number;
  dragDropProps?: DragDropProps;
  isDragDisabled?: boolean;
  children: (props: any) => any;
  onMouseOver?: (event: React.MouseEvent<HTMLElement>) => void;
  onMouseLeave?: (event: React.MouseEvent<HTMLElement>) => void;
}

const TimelineDragListItem: React.FunctionComponent<Props> = ({
  event, index, dragDropProps, isDragDisabled = false, children, ...props
}) => (
  <Draggable draggableId={event?.id} key={event?.id} index={index} isDragDisabled={!event?.isDraggable || isDragDisabled}>
    {(provided, snapshot) => {
      const style = {
        ...provided.draggableProps.style,
        transform: !snapshot.isDragging ? 'none' : provided.draggableProps.style?.transform,
      };

      const showDropZone = (event?.isStopEvent && event?.isDraggable)
        || (event?.isStartEvent && !event?.route?.isStarted && dragDropProps?.dropzonePosition === DropzonePosition.BOTTOM)
        || (event?.isEndEvent && dragDropProps?.dropzonePosition === DropzonePosition.TOP);

      return (
        <>
          <div
            {...provided.draggableProps}
            ref={provided.innerRef}
            style={style}
            {...props}
          >
            {showDropZone && dragDropProps?.dropzonePosition && dragDropProps.draggedOverIndex === index && (
              <TimelineCardDropZone type={dragDropProps.dropzonePosition} index={index} />
            )}
            {children({ provided, snapshot })}
          </div>
        </>
      );
    }}
  </Draggable>
);
export default TimelineDragListItem;
